import React from 'react'
import Header from './Header'
import Hero from './Hero'
import Footer from './Footer'

const Container = () => {
  return (
    <>
        <Header/>
        <Hero/>
        <Footer/>
    </>

  )
}

export default Container
